import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Types aligned with mf-backend/server.js responses
export interface SendNotificationResponse {
  success: boolean;
  message?: string;
  data?: string[]; // tokens array when broadcasting
  error?: string;
}

export interface SendToUserResponse {
  success: boolean;
  messageId?: string;
  token?: string;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  // Same host/port as your mf-backend server.js
  private baseUrl = 'https://squid-app-4ndr5.ondigitalocean.app';

  constructor(private http: HttpClient) {}

  // Broadcast to all users (server collects tokens from Firestore)
  sendNotification(title: string, body: string): Observable<SendNotificationResponse> {
    const url = `${this.baseUrl}/send-notification`;
    return this.http.post<SendNotificationResponse>(url, { title, body });
  }

  // Send to a specific user by Firestore userId
  sendToUser(
    userId: string,
    data?: Record<string, any>
  ): Observable<SendToUserResponse> {
    const url = `${this.baseUrl}/send-to-user`;
    return this.http.post<SendToUserResponse>(url, { userId, data });
  }
}
